/**
 * Date utility functions
 *
 * This file contains date manipulation utilities for:
 * - Date range calculations
 * - Report date range determination
 */

import { DateRange as ReportDateRangeValues } from '../../apis/graphql/types';

export const setDateRange = (startDate: Date | null, endDate: Date | null): ReportDateRangeValues =>
  startDate && endDate ? ReportDateRangeValues.Custom : ReportDateRangeValues.LifeTime;

export default setDateRange;
